import { SidePanelDetailSectionTemplate } from "components/MainSectionTemplate/SidePanelSection/SidePanelDetailSectionTemplate";
import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { invalidateTrainsCache } from "utilities/api/trainQuery";
import { useTrainDetail } from "train/useTrainDetail";
import { trainSections } from "train/trainSections";
import { getTrainFieldMetaData } from "shared/utils/fieldsHelper/trainFields";
import { SidePanelLinkedShowList } from "../SidePanelLinkedShowList";

interface TrainSidePanelDetailsProps {
  trainSidePanelData: server.dto.TrainSidePanelData
  refetch: () => Promise<void>
}

export const TrainSidePanelDetails = (props: TrainSidePanelDetailsProps) => {
  const {
    state,
    onValueChanged,
    onSuccessfulUpdate,
    refetchFiles,
    getUpdateTrainDetails,
  } = useTrainDetail(
    props.trainSidePanelData.train,
    props.trainSidePanelData.passengers,
    props.trainSidePanelData.files,
    () => { },
    () => { },
    () => { }
  );

  const queryClient = useQueryClient();

  const onSuccessfulUpdateSidePanel = async (key: string, value: any) => {
    await onSuccessfulUpdate(key, value);
    invalidateTrainsCache(queryClient);
  }

  const fieldMetaData = getTrainFieldMetaData(site.currentEnvironment, state, props.trainSidePanelData.train.permissions);

  const [mainSection, ...otherSections] = trainSections(state, fieldMetaData, refetchFiles, getUpdateTrainDetails);
  const sections = [{ ...mainSection, hideTitle: true }, ...otherSections];

  return <SidePanelDetailSectionTemplate
    isInPageEditable={props.trainSidePanelData.train.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdateSidePanel}
    sections={sections}
    additionalContent={<>
      <SidePanelLinkedShowList
        linkedShows={props.trainSidePanelData.linkedShows}
        linkShowToTravel={{
          canLink: props.trainSidePanelData.train.permissions.canModify,
          travelType: "train",
          travelId: props.trainSidePanelData.train.trainId,
          appointmentDateTime: props.trainSidePanelData.train.dateTime,
          artist: props.trainSidePanelData.train.artist,
          linkedShowIds: props.trainSidePanelData.linkedShows.map(show => show.showId),
          onLinked: props.refetch
        }}
      />
    </>}
  />
}
